import React from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { formatSalesValue } from '../../../utils/formatUtils';

const ReqListTable = ({
    list,
    editingIndex,
    handleEdit,
    handleDelete
}) => {

    // totals
    const totalQty = list.reduce((sum, item) => sum + (Number(item.Quantity) || 0), 0);
    const grandTotal = list.reduce(
        (sum, item) => sum + ((Number(item.Quantity) || 0) * (Number(item.Rate) || 0)),
        0
    );

    return (
        <div className='w-2/3 rounded-sm shadow-md overflow-hidden'>
            <div className="overflow-auto max-h-[420px] tiny-scrollbar">
                <table className="w-full text-center text-sm h-full">

                    {/* HEADER */}
                    <thead className="bg-gray-100 sticky top-0 z-20">
                        <tr>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Item</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">UOM</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Stock</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Qty</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Rate</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Total</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Actions</th>
                        </tr>
                    </thead>

                    {/* BODY */}
                    <tbody className="divide-y divide-gray-200">
                        {list.length === 0 ? (
                            <tr>
                                <td colSpan="7" className="p-4 text-gray-500 text-sm">
                                    No items added yet
                                </td>
                            </tr>
                        ) : (
                            list.map((item, index) => {
                                const total = (Number(item.Quantity) || 0) * (Number(item.Rate) || 0);

                                return (
                                    <tr
                                        key={index}
                                        className={editingIndex === index ? 'bg-blue-50' : ''}
                                    >
                                        <td className="p-2 text-gray-600">{item.ItemName}</td>
                                        <td className="p-2 text-gray-600">{item.UOM}</td>
                                        <td className="p-2 text-gray-600">{item.CurrentLevel}</td>
                                        <td className="p-2 text-gray-600">{item.Quantity}</td>
                                        <td className="p-2 text-gray-600">{formatSalesValue(item.Rate)}</td>
                                        <td className="p-2 text-gray-700 font-medium">
                                            {formatSalesValue(total)}
                                        </td>

                                        <td className="p-2">
                                            <div className="flex items-center justify-center gap-1">
                                                <button
                                                    onClick={() => handleEdit(index)}
                                                    className="h-7 w-7 flex items-center justify-center rounded border border-gray-300 text-blue-600 hover:bg-blue-50"
                                                >
                                                    <FaPencilAlt className="h-3 w-3" />
                                                </button>

                                                <button
                                                    onClick={() => handleDelete(index)}
                                                    className="h-7 w-7 flex items-center justify-center rounded border border-gray-300 text-red-600 hover:bg-red-50"
                                                >
                                                    <FaTrashAlt className="h-3 w-3" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>

                    {/* FOOTER TOTALS */}
                    {list.length > 0 && (
                        <tfoot className="bg-gray-100 sticky bottom-0">
                            <tr className="font-semibold text-gray-800">
                                <td colSpan="3" className="p-2 text-right">Totals:</td>
                                <td className="p-2">{totalQty}</td>
                                <td></td>
                                <td className="p-2">{formatSalesValue(grandTotal)}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    )}

                </table>
            </div>
        </div>
    )
}

export default ReqListTable;